import React from 'react';
import type { Channel } from 'planby';
import classNames from 'classnames';
import { testId } from '@jwp/ott-common/src/utils/common';

import Image from '../Image/Image';

import styles from './EpgChannelItem.module.scss';

type Props = {
  channel: Channel;
  channelItemWidth: number;
  sidebarWidth: number;
  onClick?: (channel: Channel) => void;
  isActive: boolean;
  title: string;
};

const EpgChannelItem: React.FC<Props> = ({ channel, channelItemWidth, sidebarWidth, onClick, isActive, title }) => {
  const { position, uuid, channelLogoImage } = channel;
  const style = { top: position.top, height: position.height, width: sidebarWidth };
  // const style = { top: position.top, height: 60, width: 66 };

  return (
    <div className={styles.epgChannelBox} style={style}>
      <div
        className={classNames(styles.epgChannel, { [styles.active]: isActive })}
        style={{ width: sidebarWidth }}
        onClick={() => onClick && onClick(channel)}
        data-testid={testId(uuid)}
        role="button"
      >
        {channelLogoImage ? (
          <Image className={styles.epgChannelLogo} image={channelLogoImage} alt={title} width={320} />
        ) : (
          <p className={styles.titleText}>{title}</p>
        )}
      </div>
    </div>
  );
};

export default EpgChannelItem;
